const { fetch: originalFetch } = window;

const filterSortPaging = (args) => {
  const [resource, config] = args;
  if (
    (config.pageNumber === null ||
      config?.pageNumber === undefined ||
      config?.pageNumber < 0) &&
    !config.filterBy &&
    !config.sortValue
  )
    return '';
  let result = resource.includes('?') ? '&' : '?';

  if (config?.pageNumber || config?.pageNumber >= 0) {
    result += `PageNumber=${config.pageNumber}`;
    if (config.pageSize && config.pageSize > 0) {
      result += `&PageSize=${config.pageSize}`;
    }
  }

  if (
    config.filterExpression &&
    Array.isArray(config.filterExpression) &&
    config.filterExpression.length > 0
  ) {
    result += `${config.filterExpression.reduce((acc, cur) => {
      return `${acc}{"${
        cur.filterBy === '' || cur.filterBy === 'All' ? '*' : cur.filterBy
      }":${
        Array.isArray(cur.filterValue)
          ? `{"${cur.operator === '!in' ? '!in' : 'in'}":[${cur.filterValue
              .map((x) => `"${String(x).replace('"', "'")}"`)
              .join(',')}]`
          : `{"${cur.operator || 'like'}":${cur.filterValue === null ? 'null' : `"${cur.filterValue}"`}`
      }}${`,"g":${cur.group || 0}`}},`;
    }, '&filter=[')}]`;
  }
  if (config.sortExpression) {
    if (
      Array.isArray(config.sortExpression) &&
      config.sortExpression.length > 0
    ) {
      result += `&sort=${config.sortExpression.map(
        ({ sortValue, sort }, index) =>
          `${sortValue}:${sort}${
            index === config.sortExpression.length - 1 ? ',' : ''
          }`
      )}`;
    } else
      result += `&sort=${config.sortExpression.sortValue}:${config.sortExpression.sort}`;
  }

  return result;
};

export default function fetch(...args) {
  let [resource, config] = args;
  config = { ...{}, ...config };
  if (!config.headers) config.headers = {};

  if (!config?.multipart) {
    config.headers['Content-Type'] = 'application/json';
  }
  config.credentials = 'include';

  resource = `${window.databeasy?.API_URL}${resource}${filterSortPaging(args)}`;

  const response = originalFetch(resource, config);

  return response;
}
